<template>
    <div id="optimizeContainer">
        <div id="optTitle">
            <p>系统优化</p>
            <div>
                <router-link to="/product?id=0" tag="span">查看更多优化服务 ></router-link>
            </div>
        </div>
        <div id="optimizeWrapper">
            <el-tabs v-model="activeName">
                <el-tab-pane label="供水管网区块化管理" name="first">
                    <div class="optBg optBg-one">
                        <div class="optCont">
                            <div class="optText">
                                三博专家为供水企业提供供水管网区块化管理的全面解决方案。通过建立管网水力模型，制定科学合理的分区方案。区块化管理可均衡管网压力，显著降低管网漏失率，降低产销差，减小水龄，保障管网水质，从根本上提高供水企业的管理水平，保障供水的安全可靠性。
                            </div>
                            <router-link to="/product?id=1" tag="span">查看更多</router-link>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="降低供水产销差" name="second">
                    <div class="optBg optBg-two">
                        <div class="optCont">
                            <div class="optText">
                                天津三博水科技公司通过建立供水管网水力模型，对整个供水网络进行建模，并从SCADA系统获取管网的实时信息进行实时模拟，将监测、设计，模型管理，泄漏管理，调度，施工维护，信息管理和专家系统等各职能进行整合，形成适合供水企业日常运营的全面高效管理平台，有效降低产销差。
                            </div>
                            <router-link to="/product?id=2" tag="span">查看更多</router-link>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="供水管网水质" name="third">
                    <div class="optBg optBg-three">
                        <div class="optCont">
                            <div class="optText">
                                天津三博通过建立管网动态水质模型，预测管网水质随空间和时间的变化规律，实时模拟管网的水质状况，为改善管网水质提供科学的依据。三博能够帮助供水企业有效减少管网二次污染，提高供水安全性。
                            </div>
                            <router-link to="/product?id=5" tag="span">查看更多</router-link>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs> 
        </div>
    </div>
</template>

<script>
export default {
    name: 'Screen6',
    data() {
        return {
            activeName: 'first'
        };
    },
}
</script>

<style scoped>
    #optimizeContainer{
        background: #f3f3f5;
        border-top:1px solid #797979; 
        padding: 35px 0 15px 0;
    }
    #optimizeWrapper{
        width: 1120PX;
        margin: 0 auto;
    }
    #optTitle{
        margin-bottom: 20px;
    }
    #optTitle>p{
        font-size: 21px;
        font-weight: bold;
        text-align: center;
    }
    #optTitle>div{
        font-size: 12px;
        color: #026fd3;
        text-align: center;
        line-height: 30px;
    }
    #optTitle>div>span{
        cursor: pointer;
    }
    .optBg{
        padding: 75px 0 35px 70px;
        height: 175px;
        font-size: 14px;
        color: #fff;
    }
    .optText{
        width: 495px;
        text-indent: 28px;
        line-height: 22px;
    }
    .optCont span{
        padding: 10px 30px;
        position: absolute;
        bottom: 35px;
        background: #1865f1;
        cursor: pointer;
        border-radius: 5px;
    }
    .optBg-one{
        background: url(../../assets/imgs/home/opt1.png); 
        background-size: 100% 100%;  
    }
    .optBg-two{
        background: url(../../assets/imgs/home/opt2.jpg); 
        background-size: 100% 100%;  
    }
    .optBg-three{
        background: url(../../assets/imgs/home/opt3.jpg); 
        background-size: 100% 100%;  
    }
  
</style>
